/* Copyright (c) 2024 Xperi. All Rights Reserved. */

/* eslint-disable simple-import-sort/imports */
/* eslint-disable prettier/prettier */
import { showGuideScreen, showMainSettingsScreen } from '../../screens/screens.reducers';
// __START_DEBUG_CODE_CLEANUP__
import { DeviceModel } from '../../../core/device';
import { signOut } from '../accountsoverlays/accountsoverlays.reducers';
import { DebugScreenController } from '../../../core/debugscreen';

let passcode: string = '';
// __END_DEBUG_CODE_CLEANUP__

export const onKeyBackInfoScreen = () => (dispatch: Function) => {
// __START_DEBUG_CODE_CLEANUP__
    passcode = '';
// __END_DEBUG_CODE_CLEANUP__
    dispatch(showMainSettingsScreen());
};

// __START_DEBUG_CODE_CLEANUP__
export const onKeyDigitInfoScreen = () => async (dispatch: Function, getState: Function) => {
    const { key } = getState().inputFactory;
    passcode = `${passcode}${key}`;
    if (DeviceModel.isValidPasscode(passcode)) {
        await dispatch(signOut());
        DeviceModel.enableBackdoor(passcode);
    }
    else if (DeviceModel.isValidPasscodeForDebugScreen(passcode)) {
        passcode = '';
        DebugScreenController.getInstance().toggleScreen();
    }
};
// __END_DEBUG_CODE_CLEANUP__

export const onKeyGuideInfoScreen = () => (dispatch: Function) => {
// __START_DEBUG_CODE_CLEANUP__
    passcode = '';
// __END_DEBUG_CODE_CLEANUP__
    dispatch(showGuideScreen());
};
